<template>
	<div>
		<PageHeaderLayout>
			<el-button type="" style="margin-bottom: 10px;" @click="goBack()"  icon="el-icon-back" size="medium">
				返回
			</el-button>
			<div class="main-page-content"
				v-loading="loadingStaus"
				:element-loading-text="loadingText">
				<el-button type="primary" style="margin-bottom: 10px;" @click="update()" size="medium">
					{{cantEdit?'修改':'查看'}}
				</el-button>
				<el-row :gutter="48">
					<el-form ref="companyForm" :model="formData" :rules="rules" label-width="140px">
						<el-col :span="18">
							<el-form-item label="公司名称" prop="company_name">
								<el-input :disabled="cantEdit" v-model="formData.company_name"></el-input>
							</el-form-item>
							<el-form-item :label="project_status?'企业联系人姓名':'企业负责人姓名'" prop="contact">
								<el-input :disabled="cantEdit" v-model="formData.contact"></el-input>
							</el-form-item>
							<el-form-item :label="project_status?'企业联系人手机号':'企业负责人手机号'" prop="phone">
								<el-input :disabled="cantEdit" type="input" v-model="formData.contact_phone"></el-input>
							</el-form-item>
							<el-form-item label="人数规模" v-if="!project_status" prop="number">
								<el-select :disabled="cantEdit" v-model="formData.num_text" class="m-2" placeholder="请选择可提供人数" size="small">
								<el-option
									v-for="item in enterTag.provideList"
									:key="item.value"
									:label="item.label"
									:value="item.value"
																/>
								</el-select>
							</el-form-item>
							<el-form-item label="企业税号" v-if="!project_status" prop="number">
								<el-input :disabled="cantEdit" type="input" v-model="formData.taxpayer"></el-input>
							</el-form-item>
                            <el-form-item label="是否上市" prop="is_up_market">
								<el-select :disabled="cantEdit" v-model="formData.is_up_market">
									<el-option
                                      v-for="item in shiList"
                                      :key="item.value"
                                      :label="item.label"
                                      :value="item.value"
                                    />
								</el-select>
                            </el-form-item>
                            <el-form-item v-if="formData.financing_level" label="融资阶段" prop="financing_level">
                              <el-select :disabled="cantEdit" v-model="formData.financing_level" class="m-2" placeholder="请选择融资阶段" size="small">
                                <el-option
                                  v-for="item in financingList"
                                  :key="item.value"
                                  :label="item.label"
                                  :value="item.value"
								/>
                              </el-select>
                            </el-form-item>
                            <el-form-item label="企业标签" prop="label_arr">
                                <span v-for="(item,index) in formData.label_arr" :key="index" class="tag">
                                    <el-tag>{{item}}</el-tag>
                                </span>
                                <el-button v-show="cantEdit==false" @click="event_addTag" type="primary" class="">添加</el-button>  
                            </el-form-item>
							<el-form-item label="企业资质:">
								<el-form-item label="营业执照" prop="image">
									<el-image v-show="cantEdit==true" :preview-src-list="[formData.business_license]" class="idImg" :src="formData.business_license">
                                        <template #error>
                                          <div class="image-slot" @click="mxGoUrl(formData.business_license)">
                                            查看图片
                                          </div>
                                        </template>
                                    </el-image>
									
									<uploadRechargeImg v-show="cantEdit==false" :imageUrl="formData.business_license" v-if="ossData.ossAccessKeyId" @handleSuccess='RechargImgSuccess($event,"business_license")'
										@handleRemove='RechargImgRemove($event,"business_license")' :ossData='ossData' :ossObj="ossObj"
										class="upload-item"></uploadRechargeImg>
										
								</el-form-item>
								<el-form-item label="企业授权书" prop="image1">
									<div v-for="(item, index) in formData.authorization" v-bind:key="index">
										<el-image :preview-src-list="[item]" class="idImg" :src="item" v-show="cantEdit==true">
                                            <template #error>
                                              <div class="image-slot" @click="mxGoUrl(item)">
                                                查看图片
                                              </div>
                                            </template>
                                        </el-image>
										
										<uploadRechargeImg v-show="cantEdit==false" :imageUrl="formData.authorization[0]" v-if="ossData.ossAccessKeyId" @handleSuccess='RechargImgSuccess($event,"authorization")'
											@handleRemove='RechargImgRemove($event,"authorization")' :ossData='ossData' :ossObj="ossObj"
											class="upload-item"></uploadRechargeImg>
									</div>
								</el-form-item>
							</el-form-item>
                            <el-form-item v-if="!project_status" label="人力资源许可证/劳务派遣证:">
                                    <el-image v-show="cantEdit==true" :preview-src-list="[formData.human_resources_license]" class="idImg" :src="formData.human_resources_license">
                                        <template #error>
                                          <div class="image-slot" @click="mxGoUrl(formData.human_resources_license)">
                                            查看图片
                                          </div>
                                        </template>
                                    </el-image>
									<uploadRechargeImg v-show="cantEdit==false" :imageUrl="formData.human_resources_license" v-if="ossData.ossAccessKeyId" @handleSuccess='RechargImgSuccess($event,"human_resources_license")'
										@handleRemove='RechargImgRemove($event,"human_resources_license")' :ossData='ossData' :ossObj="ossObj"
										class="upload-item"></uploadRechargeImg>
                            </el-form-item>	
							<el-form-item label="公司主营业务" v-if="project_status" prop="address">
								<el-input :disabled="cantEdit" type="textarea" rows="8" v-model="formData.desc"></el-input>
							</el-form-item>
							<el-form-item :label="project_status?'公司业务地区':'可承接地区'" prop="location">
								<div class="serviceArea">
									<div class="wrap">
										<el-tag v-for="(item,index) in selectedAddress1" :key="index" class="tag-address"
											:closable="!cantEdit" :disable-transitions="false" @close="handleCloseTag1(index)">
											{{item.address}}
										</el-tag>
									</div>
									<el-button v-show="!cantEdit" type="primary" @click="openServiceArea(1)" size="medium">添加</el-button>
								</div>
								<!-- <el-input :disabled="cantEdit" type="input" v-model="formData.location"></el-input> -->
							</el-form-item>
                            <el-form-item :label="project_status?'所需用工区域':'可服务区域'" prop="addressStr">
                                <el-input disabled type="input" v-model="formData.addressStr"></el-input>
                            </el-form-item>
                            <el-form-item :label="project_status?'所需岗位':'可提供岗位'" prop="job">
                                <el-input disabled type="input" v-model="formData.jobStr"></el-input>
                            </el-form-item>
							<el-form-item label="可提供人数" prop="label_num_text" v-if="!project_status">
								<el-select :disabled="cantEdit" v-model="formData.label_num_text" class="m-2" placeholder="请选择可提供人数" size="small">
								<el-option
									v-for="item in enterTag.provideList"
									:key="item.value"
									:label="item.label"
									:value="item.value"
																/>
								</el-select>
							</el-form-item>
							<el-form-item v-if="!project_status" label="可承接业务范围和项目经验" prop="content">
								<el-input type="textarea" rows="8" v-model="formData.desc"></el-input>
							</el-form-item>
							<el-form-item label="附加材料:">
								<el-form-item label="" prop="image1">
									<div v-show="cantEdit==true" v-for="(item, index) in formData.additional_materials_list" v-bind:key="index" style="display: inline-block;margin-left: 10px;">
										<el-image :preview-src-list="[item]" style="width: 200px;height: 200px;" :src="item">
                                            <template #error>
                                              <div class="image-slot" @click="mxGoUrl(item)">
                                                查看图片
                                              </div>
                                            </template>
                                        </el-image>
									</div>
									
									<div class="extraImg" v-if="ossData.ossAccessKeyId&&cantEdit==false">
										<uploadRechargeImg :imageUrl="formData.additional_materials_list[index]" @handleSuccess='RechargImgSuccess($event,"extraImg",index)'
											@handleRemove='RechargImgRemove($event,"extraImg",index)' :key="index" v-for="(item,index) in extraImgArr" :ossData='ossData' :ossObj="ossObj"
											class="upload-item"></uploadRechargeImg>
									</div>

								</el-form-item>
							</el-form-item>
							<el-form-item>
								<el-button v-show="cantEdit==false" type="primary" style="margin-bottom: 10px;" @click="ensureForm" size="medium">
									确认
								</el-button>
							</el-form-item>
						</el-col>
					</el-form>
				</el-row>
				<!-- 预览图片弹框 -->
				<el-dialog 
					:title="'预览图片'"
					:visible.sync="dialogVisible" 
					:modal="false"
					:width="'25%'"
				>
					<div class="block" v-if="dialogVisible">
						<img :src="this.imageUrl" class="preview">
					</div>
				</el-dialog>
			</div>
		</PageHeaderLayout>
		
		<el-dialog top="23vh" width="60%" :visible.sync="dialogAddress" title="">
			<div class="mainMsg pop_code">
				<div class="mainAddress_area">
					<div class="left">
						<label class="leftLabel">已选择</label>
						<div class="selectAddress_area">
							<el-tag v-for="(item,index) in selectedAddress" :key="index" class="tag-address"
								closable :disable-transitions="false" @close="handleCloseTag(index)">
								{{item.address}}
							</el-tag>
						</div>
					</div>
					<div class="right">
						<label class="leftLabel">请选择地区</label>
						<el-cascader-panel class="selectAreaWrap" ref="ref_cas" v-model="cascaderAddress"
							:options="addressOptions" :props="addressProps" />
					</div>
				</div>
		
				<div class="btn-address">
					<el-button class="ensure_code" @click="dialogAddress = false" type="primary">完成</el-button>
					<el-button class="ensure_code" @click="event_ensureAddress" type="primary">添加</el-button>
				</div>
			</div>
		</el-dialog>
		
		<!-- 公司业务地区 -->
		<el-dialog top="23vh" width="60%" :visible.sync="dialogAddress1" title="">
			<div class="mainMsg pop_code">
				<div class="mainAddress_area">
					<div class="left">
						<label class="leftLabel">已选择</label>
						<div class="selectAddress_area">
							<el-tag v-for="(item,index) in selectedAddress1" :key="index" class="tag-address"
								closable :disable-transitions="false" @close="handleCloseTag1(index)">
								{{item.address}}
							</el-tag>
						</div>
					</div>
					<div class="right">
						<label class="leftLabel">请选择地区</label>
						<el-cascader-panel class="selectAreaWrap" ref="ref_cas" v-model="cascaderAddress"
							:options="addressOptions" :props="addressProps" />
					</div>
				</div>
		
				<div class="btn-address">
					<el-button class="ensure_code" @click="dialogAddress1 = false" type="primary">完成</el-button>
					<el-button class="ensure_code" @click="event_ensureAddress1" type="primary">添加</el-button>
				</div>
			</div>
		</el-dialog>
		
		<el-dialog :visible.sync="enterpriseShow" width="70%" title="企业标签" class="tagArea">
			<el-form ref="companyForm" :model="formData" :rules="rules" label-width="140px">
				<el-form-item label="可服务行业" prop="content">
					<el-checkbox-group size="mini" v-model="formData.label_category_type_ids" :disabled="cantEdit">
						<el-checkbox size="mini" :label="item.val" border v-for="(item,index) in financingStageArr"
							:key='index'>{{item.label}}
						</el-checkbox>
					</el-checkbox-group>
				</el-form-item>
				<el-form-item label="可服务区域" prop="content">
					<div class="serviceArea">
						<div class="wrap">
							<el-tag v-for="(item,index) in selectedAddress" :key="index" class="tag-address"
								closable :disable-transitions="false" @close="handleCloseTag(index)">
								{{item.address}}
							</el-tag>
						</div>
						<el-button type="primary" @click="openServiceArea(2)" size="medium">添加</el-button>
					</div>
				</el-form-item>
				<el-form-item label="当前是否承接" prop="content">
					<el-radio-group v-model="formData.isChengjie">
						<el-radio label="2">否</el-radio>
						<el-radio label="1">是</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item label="承接类型" prop="content">
					<el-checkbox-group size="mini" v-model="formData.label_undertake_type" :disabled="cantEdit">
						<el-checkbox size="mini" :label="item.val" border v-for="(item,index) in chengjieTypeArr"
							:key='index'>{{item.label}}
						</el-checkbox>
					</el-checkbox-group>
				</el-form-item>
				<el-form-item label="服务方式" prop="content">
					<el-checkbox-group size="mini" v-model="formData.label_service_type" :disabled="cantEdit">
						<el-checkbox size="mini" :label="item.val" border v-for="(item,index) in serviceTypeArr"
							:key='index'>{{item.label}}
						</el-checkbox>
					</el-checkbox-group>
				</el-form-item>
				<el-form-item label="工作类型" prop="content">
					<el-checkbox-group size="mini" v-model="formData.label_work_type" :disabled="cantEdit">
						<el-checkbox size="mini" :label="item.val" border v-for="(item,index) in workTypeArr"
							:key='index'>{{item.label}}
						</el-checkbox>
					</el-checkbox-group>
				</el-form-item>
				<el-form-item label="可提供岗位" prop="content">
					<div class="wrap_column">
						<div>
							<el-input class="input" v-model="formData.jobName" placeholder="请输入岗位名称"></el-input>
							<el-button type="primary" @click="addTag('job')" size="medium">增加</el-button>
						</div>
						<div class="textarea">
							<el-tag
							@close="removeJobTag(index)"
							v-for="(item,index) in formData.job"
							:key="index"
							class="item"
							closable
							type="primary">
							{{item.job_name}}
							</el-tag>
						</div>
					</div>
				</el-form-item>
				<el-form-item label="自定义" prop="content">
					<div class="wrap_column">
						<div>
							<el-input class="input" v-model="formData.tagName" placeholder="请输入标签名称"></el-input>
							<el-button type="primary" @click="addTag('custom')" size="medium">增加</el-button>
						</div>
						<div class="textarea">
							<el-tag
							@close="removeLabelTag(index)"
							v-for="(item,index) in formData.label"
							:key="index"
							class="item"
							closable
							type="primary">
							{{item.custom_label}}
							</el-tag>
						</div>
					</div>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" @click="enterpriseShow=false">确认</el-button>
				</el-form-item>
			</el-form>
		</el-dialog>
	</div>
</template>

<script>
import uploadRechargeImg from './uploadRechargeImg.vue'
import PageHeaderLayout from '@/layouts/PageHeaderLayout'
import UploadFile from "@/components/UploadFile";
import { mapGetters } from 'vuex'

export default {
	components: {
		PageHeaderLayout,
		UploadFile,
		uploadRechargeImg
	},
	data() {
		return {
			extraImgArr:['','',''],
			ossData: {},
			ossObj: {},
			dialogAddress1:false,
			dialogAddress:false,
			selectedAddress_location:[],
			selectedAddress_address:[],
			selectedAddress1:[],
			selectedAddress: [],
			cascaderAddress: [],
			addressOptions: [],
			addressProps: {
				checkStrictly: true
			},
			workTypeArr:[
				{
					label:'全职',
					val:1
				},
				{
					label:'兼职',
					val:2
				}
			],
			serviceTypeArr:[
				{
					label:'线上服务',
					val:1
				},
				{
					label:'线下服务',
					val:2
				}
			],
			chengjieTypeArr:[
				{
					label:'BPO',
					val:1
				},
				{
					label:'RPO',
					val:2
				}
			],
			financingStageArr:[],
			enterTag:{
				provideList:[
					{
						label:'10-50',
						value:'10-50'
					},
					{
						label:'50-100',
						value:'50-100'
					},
					{
						label:'100-300',
						value:'100-300'
					},
					{
						label:'300-500',
						value:'300-500'
					},
					{
						label:'500+',
						value:'500-99999'
					}
				]
			},
			enterpriseShow:false,
			shiList:[
				{
					label:'是',
					value:'1'
				},
				{
					label:'否',
					value:'2'
				}
			],
			financingList:[
				{
					label:'不需要融资',
					value:'9'
				},
				{
					label:'天使轮',
					value:'8'
				},
				{
					label:'A轮',
					value:'7'
				},
				{
					label:'B轮',
					value:'6'
				},
				{
					label:'C轮',
					value:'5'
				},
				{
					label:'D轮',
					value:'4'
				},
				{
					label:'E轮',
					value:'3'
				},
				{
					label:'F轮',
					value:'2'
				},
				{
					label:'上市',
					value:'1'
				}
			],
			cantEdit:true,
            financingStageList: {'9':{
                label: '不需要融资',
                name: 9
            }, '8':{
                label: '天使轮',
                name: 8
            }, '7':{
                label: 'A轮',
                name: 7
            }, '6':{
                label: 'B轮',
                name: 6
            }, '5':{
                label: 'C轮',
                name: 5
            }, '4':{
                label: 'D轮',
                name: 4
            }, '3':{
                label: 'E轮',
                name: 3
            }, '2':{
                label: 'F轮',
                name: 2
            }, '1':{
                label: '上市',
                name: 1
            }},
			dialogVisible: false,
			activeTab: '0',
			hearTitle: '基本设置',
			loadingStaus: true,
			loadingText: '正在提交中……',
			formDisabled: false,
			billId:0, // 公司id，0表示创建，非零为编辑
			// element的cascader的props值
			cascaderProps:{
				label:'display_name',
				value:'id',
			},
			// 分类列表
			categoryList:[],
			openapiList:[],
			// 标签
			categoryLabelList:[],
			// 已选中的分类列表，用于cascader组件选中效果
			selectedList:[],
			// 已选中标签
			selectedLabelList:[],
			// 公司基本信息表单结构
			formData:{
				financingStageArr:[]
			},
			// 已上传图片列表
			uploadFileList:[],
			// 公司基本信息规则
			rules: {
				name: [
					{required: true, message: '输入公司名称', trigger: 'blur' },
				],
				file_url: [
					{required: true, message: '输入文件名称', trigger: 'blur' },
				]
			},
			// 附件类型
			attachmentType:['application/pdf','application/caj','','application/zip','application/rar','application/doc'],
			// 已上传附件列表
			attachmentUploadFileList:[],
			imageUrl: '',//图片地址
			project_status:this.$route.query.project_status.toString()=='true'?true:false,
			company_id:this.$route.query.id
		}
	},
	computed: {
		...mapGetters(['userPermissions']),
	},
	methods: {
		//移除
		RechargImgRemove(url, param,index) {
			if(param == 'authorization'){
				this.formData.authorization[0] = ''
				return false
			}
			if(param == 'extraImg'){
				this.extraImgArr[index] = ''
				return false
			}
			this.formData[param] = ''
		},
		//成功
		RechargImgSuccess(url, param,index) {
			if(param == 'authorization'){
				this.formData.authorization[0] = url
				return false
			}
			if(param == 'extraImg'){
				this.extraImgArr[index] = url
				return false
			}
			this.formData[param] = url
		},
		async ossUpload() {
			const res_oss = await this.$api.getOss({
				dir: 'ph/hr/'
			})
			if (res_oss) {
				this.ossObj = res_oss
				this.ossData = {
					ossAccessKeyId: res_oss.accessid,
					policy: res_oss.policy,
					signature: res_oss.signature
				}
			} else {
				this.$message.error('获取oss签名失败')
			}
		},
		async ensureForm(){
			this.formData.additional_materials = this.extraImgArr
			this.formData.additional_materials = JSON.stringify(this.formData.additional_materials)
			let {company_name,contact,contact_phone,is_up_market,financing_level,desc,locations,business_license,authorization,label_category_type_ids,
			urgency_of_demand,label_undertake_type,address,label_service_type,label_work_type,label,job,taxpayer,num_text,label_num_text,label_is_undertake,
			additional_materials} = this.formData
			locations.map(item=>{
				if(item.location){
					if(item.location[0]){
						item.province_code = Number(item.location[0])
					}
					
					if(item.location[1]){
						item.city_code = Number(item.location[1])
					}else{
						item.city_code = 0
					}
					
					if(item.location[2]){
						item.district_code = Number(item.location[2])
					}else{
						item.district_code = 0
					}
					delete item.location
				}
			})
			address.map(item=>{
				if(item.location){
					if(item.location[0]){
						item.province_code = Number(item.location[0])
					}
					
					if(item.location[1]){
						item.city_code = Number(item.location[1])
					}else{
						item.city_code = 0
					}
					
					if(item.location[2]){
						item.district_code = Number(item.location[2])
					}else{
						item.district_code = 0
					}
					delete item.location
				}
			})
			let obj = {
				company_name,
				contact,
				contact_phone,
				is_up_market,
				financing_level,
				desc,
				locations,
				business_license,
				authorization,
				label_category_type_ids,
				urgency_of_demand,
				label_undertake_type,
				address,
				label_service_type,
				label_work_type,
				label,
				job,
				additional_materials
			}
			
			let obj2 = {
				company_name,
				contact,
				contact_phone,
				is_up_market,
				financing_level,
				desc,
				locations,
				business_license,
				authorization,
				label_category_type_ids,
				label_is_undertake,
				label_undertake_type,
				address,
				label_service_type,
				label_work_type,
				label,
				job,
				taxpayer,
				additional_materials
			}

			if(this.project_status){
				obj.urgency_of_demand = this.formData.isChengjie
				await this.$api.updateEmp(this.company_id,obj)
			}else{
				let label_num = label_num_text.split('-')
				let num = num_text.split('-')
				
				obj2.label_is_undertake = this.formData.isChengjie
				obj2.label_min_num = Number(label_num[0])
				obj2.label_max_num = Number(label_num[1])
				obj2.min_num = Number(num[0])
				obj2.max_num = Number(num[1])
				
				await this.$api.updateHr(this.company_id,obj2)
			}
			this.$message.success('操作成功')
			this.init()
		},
		handleCloseTag(index){
			this.selectedAddress.splice(index,1)
		},
		handleCloseTag1(index){
			this.selectedAddress1.splice(index,1)
		},
		async getAddressList(){
			let res = await this.$api.getAreaList({})
			this.addressOptions = res
		},
		openServiceArea(e){
			if(e==1){
				this.dialogAddress1 = !this.dialogAddress1
			}else{
				this.dialogAddress = !this.dialogAddress
			}
		},
		event_ensureAddress(){
			let arr = JSON.parse(JSON.stringify(this.cascaderAddress))
			
			if (arr.length == 0) {
				this.$message.error('请选择一个地区')
				return false
			}
			
			let addressLabel = []
			arr.map((item, index) => {
				if (index == 0) {
					this.addressOptions.map(item2 => {
						if (item == item2.value) {
							addressLabel.push(item2.label)
						}
					})
				}
			
				if (index == 1) {
					this.addressOptions.map(item2 => {
						if (item2.children) {
							item2.children.map(item3 => {
								if (item == item3.value) {
									addressLabel.push(item3.label)
								}
							})
						}
					})
				}
			
				if (index == 2) {
					this.addressOptions.map(item2 => {
						if (item2.children) {
							item2.children.map(item3 => {
								if (item3.children) {
									item3.children.map(item4 => {
										if (item == item4.value) {
											addressLabel.push(item4.label)
										}
									})
								}
							})
						}
					})
				}
			})
			
			// 检查是否存在重复
			let isHav = false
			this.selectedAddress.map(item => {
				if (item.address == addressLabel.join("-")) {
					isHav = true
				}
			})
			
			if (isHav) {
				this.$message.error('请勿添加重复地区')
				return false
			}
			
			let obj = {
				address: addressLabel.join("-"),
				location: arr
			}
			
			this.selectedAddress.push(obj)
			this.cascaderAddress = []
			
		},
		event_ensureAddress1(){
			let arr = JSON.parse(JSON.stringify(this.cascaderAddress))
			
			if (arr.length == 0) {
				this.$message.error('请选择一个地区')
				return false
			}
			
			let addressLabel = []
			arr.map((item, index) => {
				if (index == 0) {
					this.addressOptions.map(item2 => {
						if (item == item2.value) {
							addressLabel.push(item2.label)
						}
					})
				}
			
				if (index == 1) {
					this.addressOptions.map(item2 => {
						if (item2.children) {
							item2.children.map(item3 => {
								if (item == item3.value) {
									addressLabel.push(item3.label)
								}
							})
						}
					})
				}
			
				if (index == 2) {
					this.addressOptions.map(item2 => {
						if (item2.children) {
							item2.children.map(item3 => {
								if (item3.children) {
									item3.children.map(item4 => {
										if (item == item4.value) {
											addressLabel.push(item4.label)
										}
									})
								}
							})
						}
					})
				}
			})
			
			// 检查是否存在重复
			let isHav = false
			this.selectedAddress1.map(item => {
				if (item.address == addressLabel.join("-")) {
					isHav = true
				}
			})
			
			if (isHav) {
				this.$message.error('请勿添加重复地区')
				return false
			}
			
			let obj = {
				address: addressLabel.join("-"),
				location: arr
			}
			
			this.selectedAddress1.push(obj)
			this.cascaderAddress = []
			
		},
		removeLabelTag(e){
			this.formData.label.splice(e,1)
		},
		removeJobTag(e){
			this.formData.job.splice(e,1)
		},
		addTag(e){
			if(e == 'job'){
				if(this.formData.jobName == ''||this.formData.jobName == undefined){
					this.$message.error('请输入岗位名称')
					return false
				}
				let obj = {
					job_name:this.formData.jobName
				}
				
				let flag = false
				this.formData.label.map(item=>{
					if(item.jobName == this.formData.jobName){
						flag = true
					}
				})
				
				if(flag){
					this.$message.error('请勿输入重复的')
					return false
				}
				
				this.formData.job.push(obj)
			}else{
				if(this.formData.tagName == ''||this.formData.tagName == undefined){
					this.$message.error('请输入标签名称')
					return false
				}
				let obj = {
					custom_label:this.formData.tagName
				}
				let flag = false
				this.formData.label.map(item=>{
					if(item.custom_label == this.formData.tagName){
						flag = true
					}
				})
				
				if(flag){
					this.$message.error('请勿输入重复的')
					return false
				}
				
				this.formData.label.push(obj)
			}
		},
		/* 获取行业列表 */
		async getEnterpriseLable(){
			let type = 1
			const res = await this.$api.getCateList({
				type
			})
			this.financingStageArr = []
			res.map(item => {
				this.financingStageArr.push({
					label: item.label_category_name,
					val: item.id
				})
			})
			
		},
		event_addTag(){
			this.enterpriseShow = !this.enterpriseShow
		},
		update(){
			this.cantEdit = !this.cantEdit
		},
		/* 预览图片 */
		showImage(data) {
			this.dialogVisible = true;
			this.imageUrl = data;
		},
		// 返回列表
		returnList() {
			this.$router.push('/bill')
		},
		// 菜单选择
		categoryChange(v) {
			if (v) {
				this.formData.parent_id = v
			}
		},
		openapiChange(v) {
			if (v) {
				this.formData.openapi_id = v
			}
		},
		// 级联菜单组件change事件
		cascaderLabelChange(v) {
			if (v.length) {
				this.formData.category_2_id = v[(v.length-1)]
				this.formData.category_2_ids = v
			} else {
				this.formData.category_2_id = ''
				this.formData.category_2_ids = []
			}
		},
		// 级联菜单自定义验证，选择分类
		cascaderVerify(rule, value, callback) {
			if (rule.required && !this.selectedList.length) {
				callback(new Error(rule.message))
			}
			callback()
		},
		// 确认保存按钮
		async saveConfirm() {
			// 调用组件的数据验证方法
			this.$refs['companyForm'].validate((valid) => {
				if (valid) {
					this.formSubmit()
				} else {
					this.$message.error('数据验证失败，请检查必填项数据！')
				}
			})
			return true
		},
		// 公司相关信息的保存处理
		async formSubmit() {
			this.loadingStaus = true
			try {
				let id = await this.$api.saveBill(this.formData)
				if (id.length > 0) {
					this.$notify.success('保存成功！')
					if (this.billId === 0 && id) {
						this.$router.push(this.$route.matched[1].path)
					}
				}
				this.$nextTick(() => {
					this.loadingStaus = false
				})
			} catch(err) {
				console.log('err is ->', err)
			}
		},
		// 初始化公司基本信息
		async init() {
			this.getEnterpriseLable()
			if(this.company_id) {
				// this.formData = {};
				if(this.project_status) {
					let info = await this.$api.viewPaihuoEmployment(this.company_id)
					info.location = "";
                    if(info.locations.length){
                        info.locations.forEach(function(item){
                            if(info.location=="") {
                                info.location = item.address;
                            } else {
                                info.location = info.location+";"+item.address;
                            }
                        })
                    }
                    
                    if(info.address.length){
                        info.addressStr = "";
                        info.address.forEach(function(item){
                            if(info.addressStr=="") {
                                info.addressStr = item.address;
                            } else {
                                info.addressStr = info.addressStr+";"+item.address;
                            }
                        })
                    }
                    
                    info.jobStr = info.job.map(item=>item.job_name).join('、')
					
					if(info.additional_materials && info.additional_materials != "Array") {
						info.additional_materials_list = JSON.parse(info.additional_materials)
					} else {
						info.additional_materials_list = [];
					}
					info.isChengjie = info.urgency_of_demand.toString()
					info.is_up_market = info.is_up_market.toString()
					info.financing_level = info.financing_level.toString()
					this.formData = info
					this.selectedAddress = this.formData.address
					this.selectedAddress1 = this.formData.locations
					if(this.formData.additional_materials){
						let arr = JSON.parse(this.formData.additional_materials)
						if(arr[0]){
							this.extraImgArr[0] = arr[0]
						}
						if(arr[1]){
							this.extraImgArr[1] = arr[1]
						}
						if(arr[2]){
							this.extraImgArr[2] = arr[2]
						}
					}
				} else {
					let data = await this.$api.viewPaihuoHumanResources(this.company_id)
					data.location = "";
					data.locations.forEach(function(item){
						if(data.location=="") {
							data.location = item.address;
						} else {
							data.location = data.location+";"+item.address;
						}
					})
					data.addressStr = "";
					data.address.forEach(function(item){
                        if(data.addressStr=="") {
                            data.addressStr = item.address;
                        } else {
                            data.addressStr = data.addressStr+";"+item.address;
                        }
					})
                    data.jobStr = data.job.map(item=>item.job_name).join('、')
					if(data.additional_materials && data.additional_materials != "Array") {
						data.additional_materials_list = JSON.parse(data.additional_materials)
					} else {
						data.additional_materials_list = [];
					}
					data.num_text = data.min_num + " - "+ data.max_num
                    data.label_num_text = data.label_min_num + " - "+ data.label_max_num
					data.isChengjie = data.label_is_undertake.toString()
					data.is_up_market = data.is_up_market.toString()
					data.financing_level = data.financing_level.toString()
					this.formData = data
					this.selectedAddress = this.formData.address
					this.selectedAddress1 = this.formData.locations
					if(this.formData.additional_materials){
						let arr = JSON.parse(this.formData.additional_materials)
						if(arr[0]){
							this.extraImgArr[0] = arr[0]
						}
						if(arr[1]){
							this.extraImgArr[1] = arr[1]
						}
						if(arr[2]){
							this.extraImgArr[2] = arr[2]
						}
					}
				}
			}
		},
		//返回上一页
		goBack() {
			this.$router.push({ path: "/paihuo",query:{project_status:this.project_status}});
		}
	},
	async mounted() {
		this.ossUpload()
		this.getAddressList()
		this.loadingStaus = true
		this.init()
		this.$nextTick(() => {
			this.loadingStaus = false
		})
		if(this.$config.domain.ename === 'opryousuiyun') {
			this.is_ysy = true;
		}
	},
}
</script>

<style lang="stylus" scoped>
    .tagArea{
        .input{
			width: 600px
        }
    }
	
	.extraImg{
		display: flex
		flex-direction: row
		.upload-item{
			margin-right: 20px
		}
	}
	
	.mainMsg {
		width: 100%;
		display: flex
		justify-content: center
		align-items: center
		flex-direction: column
	}
	
	.mainMsg.pop_code {
		.label {
			font-size: 20px
			font-weight: 600
			color: #088CF3
			margin-bottom: 40px
		}
		
		.img {
			display: flex;
			margin-bottom: 20px
		}
		
		.sublabel {
			margin-top: 10px
			font-size: 16px
			font-weight: 600
			color: #3D4B56
		}
		
		.sublabel.last {
			margin-bottom: 40px;
		}
	}
	
	.mainAddress_area {
		display: flex
		justify-content: center
		align-items: center
		width: 1000px;
		margin-bottom: 40px;
	
		.left {
			width: 400px;
			display: flex
			justify-content: flex-start
			align-items: flex-start
			flex-direction: column
			height: 520px;
	
			.leftLabel {
				font-size: 18px
				font-weight: 600
				color: #55aaff
			}
	
			.tag-address {
				margin-top: 20px;
			}
		}
	
		.right {
			height: 520px;
	
			.leftLabel {
				font-size: 18px
				font-weight: 600
				color: #55aaff
				margin-bottom: 40px;
			}
	
			flex: 1;
			display: flex
			justify-content: flex-start
			align-items: flex-start
			flex-direction: column
		}
	
		.selectAddress_area {
			height: 520px;
			width: 304px;
			margin-top: 20px;
			display: flex
			justify-content: flex-start
			align-items: flex-start
			flex-direction: column
			overflow-y: auto;
			// ,.el-scrollbar__wrap
		}
	}
	
	.serviceArea{
		display:flex
		justify-content: flex-start
		align-items: center
		flex-direction: row
		.wrap{
			width: 300px
			margin-right: 20px
			.tag-address{
				margin-right: 10px
			}
		}
		}
	
	.wrap_column{
		display: flex
		flex-direction: column
		.input{
			margin-right: 20px;
		}
		.textarea{
			width: 670px
			height: 100px
			margin-top: 20px
			border: 1px solid #dedede
			padding: 10px
			box-sizing: border-box
			.item{
				margin-right: 10px
			}
		}
	}
	
    .image-slot{
        height: 50px
        width: 80px
        display:flex
        align-items:center
        justify-content:center
    }
  .content-left
    min-height 640px
    border-right 1px solid  #e8e8e8
    .el-cascader
      display block
      width 320px
  .back-btn
    position absolute
    right 50px
    top 150px
  .content-right
    .right-button
      border-top 1px solid #e8e8e8e8
      padding 12px 12px
    .el-form-item__label
      float none
      display inline-block
      text-align left
      padding 0 0 10px 0
    .el-form-item__content
      margin-left 0px !important
      .el-checkbox-group
        margin-top -12px
  .preview
    width: 100%	
  .idImg
    width: 100px
    cursor: pointer
    
  .tag {
    display:inline-block
    margin-right:10px
  }
      
</style>
